import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTelegram } from '../hooks/useTelegram';
import './CheckoutFailurePage.css';

export const CheckoutFailurePage: React.FC = () => {
  const navigate = useNavigate();
  const { tg } = useTelegram();

  useEffect(() => {
    // Hide back button on failure page
    if (tg?.BackButton) {
      tg.BackButton.hide();
    }
  }, [tg]);

  const handleGoHome = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className="page checkout-failure-page">
      <div className="failure-content">
        <div className="failure-icon">
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="40" fill="#F44336" opacity="0.1"/>
            <circle cx="40" cy="40" r="32" fill="#F44336" opacity="0.2"/>
            <path d="M30 30L50 50M50 30L30 50" stroke="#F44336" strokeWidth="4" strokeLinecap="round"/>
          </svg>
        </div>

        <h1 className="failure-title">Что-то пошло не так</h1>

        <div className="failure-message">
          <p>К сожалению, не удалось оформить заказ.</p>
          <p>Пожалуйста, попробуйте еще раз или свяжитесь с менеджером для помощи.</p>
        </div>

        <div className="failure-actions">
          <a
            href="https://t.me/TESTORIA_Mosk"
            target="_blank"
            rel="noopener noreferrer"
            className="failure-button primary"
          >
            Связаться с менеджером
          </a>
          <button className="failure-button secondary" onClick={handleGoHome}>
            В главное меню
          </button>
        </div>
      </div>
    </div>
  );
};
